export default function Fail(props) {
  return (
    <svg width='20.35' height='20.326' viewBox='0 0 20.35 20.326' {...props}>
      <path
        id='e924'
        d='M10.175,0A9.917,9.917,0,0,0,6.219.8,10.205,10.205,0,0,0,.8,6.207,9.832,9.832,0,0,0,0,10.151a9.891,9.891,0,0,0,.8,3.968,10.205,10.205,0,0,0,5.421,5.409,9.917,9.917,0,0,0,3.956.8,9.917,9.917,0,0,0,3.956-.8,10.205,10.205,0,0,0,5.421-5.409,9.891,9.891,0,0,0,.8-3.968,9.832,9.832,0,0,0-.8-3.944A10.205,10.205,0,0,0,14.131.8,9.917,9.917,0,0,0,10.175,0Zm4.742,13.32-1.6,1.6-3.145-3.169L7.03,14.917l-1.6-1.6,3.145-3.169L5.433,7.006l1.6-1.6,3.145,3.145L13.32,5.409l1.6,1.6-3.145,3.145Z'
        fill='#ff4848'
      />
    </svg>
  )
}
